AFRAME.registerComponent("medium-frame", {
  schema: {
  },
  init() {

  },
  resizeObject() {
    this.el.object3DMap.mesh.scale.set(1,1,1);
    this.el.object3DMap.mesh.updateMatrices();
  },
  tick() {
    this.el.object3DMap.mesh.scale.set(1,1,1);    
  },

  update(oldData) {
      this.resizeObject();
      this.resizeObject();
  },
  async onModelLoaded(event) {
    setTimeout(() => {
      this.resizeObject();
      this.resizeObject();
    }, 300);
  },
});
;